import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";
import TeamsHeader from "components/teams/TeamsHeader";
import TeamsUsedBy from "components/teams/TeamsUsedBy";
import { Page } from "types/page";

import styles from "styles/teams.module.css";
import TeamsPrivateExtensions from "components/teams/TeamsPrivateExtensions";
import TeamsSharedQuicklinks from "components/teams/TeamsSharedQuicklinks";
import TeamsSharedSnippets from "components/teams/TeamsSharedSnippets";
import TeamsPricingInfo from "components/teams/TeamsPricingInfo";
import TeamsExtensionsTemplate from "components/teams/TeamsExtensionsTemplate";
import ReadyForTakeOff from "components/ReadyForTakeOff";
import SocialFooter from "components/SocialFooter";
import Container from "components/Container";

const Teams: Page = () => {
  return (
    <Container>
      <TeamsHeader />
      <TeamsUsedBy />
      <div className={styles.titleSubtitle} id="learn-more">
        <h2>
          One organization,
          <br />
          infinite possibilities.
        </h2>

        <p>Empower your teams to build better processes, for a better workplace.</p>
      </div>

      <TeamsPrivateExtensions />
      <TeamsSharedQuicklinks />
      <TeamsSharedSnippets />

      <div className={styles.titleSubtitle}>
        <h2>Get started today</h2>

        <p>Choose which Plan suits your organization best.</p>
      </div>

      <TeamsPricingInfo />
      <TeamsExtensionsTemplate />

      <ReadyForTakeOff />

      <SocialFooter />
    </Container>
  );
};

Teams.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Teams;
